module.exports = __webpack_public_path__ + "static/media/contact.2a1a7bdb.png";